// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlignmentDownload-module__header___ogpRS {
  padding: 20px 40px 0 40px;
}
.AlignmentDownload-module__header___ogpRS .AlignmentDownload-module__button___s8Wzm {
  height: 38px;
  margin: -8px 0 8px 0;
  margin-left: auto;
}

.AlignmentDownload-module__select___tqs3Z {
  max-width: 200px;
}
.AlignmentDownload-module__select___tqs3Z > div:first-child {
  padding: 4.5px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/AlignmentDownload/AlignmentDownload.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;AACE;EACE,YAAA;EACA,oBAAA;EACA,iBAAA;AACJ;;AAGA;EACE,gBAAA;AAAF;AAEE;EACE,yBAAA;AAAJ","sourcesContent":[".header {\n  padding: 20px 40px 0 40px;\n\n  .button {\n    height: 38px;\n    margin: -8px 0 8px 0;\n    margin-left: auto;\n  }\n}\n\n.select {\n  max-width: 200px;\n\n  & > div:first-child {\n    padding: 4.5px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `AlignmentDownload-module__header___ogpRS`,
	"button": `AlignmentDownload-module__button___s8Wzm`,
	"select": `AlignmentDownload-module__select___tqs3Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
